module.exports = __webpack_public_path__ + "img/name_white.67f1f196.png";